import React from 'react';
import AudioPlayerH5 from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

const AudioPlayer = (props, ref) => {
  return <AudioPlayerH5 ref={ref} {...props} />;
};

export default React.forwardRef(AudioPlayer);
